import React from 'react';

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="205.6819763" cy="192.5350647" r="0" />
				<g className="fill--eyes eyes">
					<ellipse cx="234.6811676" cy="192.5350647" rx="7.6592607" ry="8.5102901" />
					<ellipse cx="176.6827698" cy="192.5350647" rx="7.6592607" ry="8.5102901" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M227.2812347,198.5197601c0.1542969,0,0.3105469-0.0141602,0.4677734-0.0439453l15.265625-2.8896484
						c1.3564453-0.2568359,2.2480469-1.5649414,1.9912109-2.9213867c-0.2568359-1.3569336-1.5634766-2.2470703-2.9208984-1.9916992
						l-15.265625,2.8896484c-1.3564453,0.2568359-2.2480469,1.5649414-1.9912109,2.9213867
						C225.0546722,197.6838226,226.1035004,198.5197601,227.2812347,198.5197601z" />
					<path d="M184.0827026,198.5197601c-0.1542969,0-0.3105469-0.0141602-0.4677734-0.0439453l-15.265625-2.8896484
						c-1.3564453-0.2568359-2.2480469-1.5649414-1.9912109-2.9213867c0.2568359-1.3569336,1.5634766-2.2470703,2.9208984-1.9916992
						l15.265625,2.8896484c1.3564453,0.2568359,2.2480469,1.5649414,1.9912109,2.9213867
						C186.3092651,197.6838226,185.260437,198.5197601,184.0827026,198.5197601z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M227.2850647,198.3868408c0.6044922,0,1.2099609-0.2177734,1.6904297-0.6591797
						c0.9189453-0.84375,2.9033203-1.7983398,5.7177734-1.9462891c2.8125-0.1425781,4.8876953,0.5942383,5.8896484,1.3378906
						c1.1103516,0.8237305,2.6748047,0.5908203,3.4970703-0.5170898c0.8232422-1.1083984,0.5917969-2.6743164-0.5166016-3.4975586
						c-2.234375-1.6591797-5.5507812-2.5053711-9.1318359-2.3164062c-3.5683594,0.1875-6.7900391,1.375-8.8388672,3.2578125
						c-1.0166016,0.934082-1.0839844,2.515625-0.1494141,3.5322266
						C225.9364319,198.1148682,226.6092834,198.3868408,227.2850647,198.3868408z" />
					<path d="M184.0788727,198.3868408c-0.6044922,0-1.2099609-0.2177734-1.6904297-0.6591797
						c-0.9189453-0.84375-2.9033203-1.7983398-5.7177734-1.9462891c-2.8125-0.1425781-4.8876953,0.5942383-5.8896484,1.3378906
						c-1.1103516,0.8237305-2.6748047,0.5908203-3.4970703-0.5170898c-0.8232422-1.1083984-0.5917969-2.6743164,0.5166016-3.4975586
						c2.234375-1.6591797,5.5507812-2.5053711,9.1318359-2.3164062c3.5683594,0.1875,6.7900391,1.375,8.8388672,3.2578125
						c1.0166016,0.934082,1.0839844,2.515625,0.1494141,3.5322266
						C185.4275055,198.1148682,184.7546539,198.3868408,184.0788727,198.3868408z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M184.3420258,192.5350647c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844s-7.659256-3.8101807-7.659256-8.5102844
						c0-3.0506439,3.4291687-3.0506439,7.659256-3.0506439S184.3420258,189.4844208,184.3420258,192.5350647z" />
					<path d="M242.3404236,192.5350647c0,4.7001038-3.4291687,8.5102844-7.659256,8.5102844s-7.659256-3.8101807-7.659256-8.5102844
						c0-3.0506439,3.4291687-3.0506439,7.659256-3.0506439S242.3404236,189.4844208,242.3404236,192.5350647z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tiger/Eyes.js